module.exports = __webpack_public_path__ + "img/17.31978a5f.png";